export enum emailVerificationActions {
  PUSH = 'emailVerification/push',
  REPLACE = 'emailVerification/replace',
}
